import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import style from "./Assesment.module.css";
import Grid from "@mui/material/Grid";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import CommonButton from "../../../CommonComponents/CommonButton";
import TextField from "@mui/material/TextField";
import MuiTab from "../../../CommonComponents/Tab/MuiTab";
import {
  getVendorAssessmentData,
  putVendorAssessmentData,
} from "../../../Services/approval.service";
import useToaster from "../../../customHook/useToaster";
import {
  reportStatusOptions,
  options,
  reportStandardValObj,
} from "../../../constants/approvalsData";
import CommonLoader from "../../../CommonComponents/CommonLoader/CommonLoader";

export default function VendorAssesment({
  setOpenActionModal,
  caseId,
  vendorId,
  vendorIdToDisplay,
  vendorBlockActiveTabValue,
}) {
  const [vendorsDetails, setVendorsDetails] = useState([]);
  const [vendorTabs, setVendorTabs] = useState([]);
  const [vendorTabIndex, setVendorTabIndex] = useState(0);
  const [vendorAssesmentRequired, setVendorAssesmentRequired] = useState(true);
  const [loader, setLoader] = useState(false);
  // const vendorTabIndex = vendorIdToDisplay
  //   ? vendorIdToDisplay - 1
  //   : vendorTabIndex;
  const { showToast } = useToaster();

  const vendorChangeClickHandler = (event, newValue) => {
    setVendorTabIndex(newValue);
  };
  const submit = async () => {
    if (
      Number(
        vendorsDetails[vendorTabIndex]?.assessmentDetails?.blockCompleted
      ) > 0
    ) {
      try {
        const data = await putVendorAssessmentData(caseId, {
          vendorId: vendorsDetails[vendorTabIndex]?.assessmentDetails?.vendorId,
          reportStatus:
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStatus,
          reportStandard:
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStandard,
          finalScore:
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.qualityScore *
              0.6 +
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.tatScore,
          remarks: vendorsDetails[vendorTabIndex]?.assessmentDetails?.remarks,
          submit: true,
        });

        if (data.success) {
          // debugger;
          showToast(data?.message, "success", true);
          let checkToCloseModal = true;
          vendorsDetails.forEach((item) => {
            if (
              item.assessmentStatus !== "completed" &&
              vendorsDetails[vendorTabIndex]?.assessmentDetails?.vendorId !==
                item?.assessmentDetails?.vendorId
            ) {
              checkToCloseModal = false;
            }
          });
          if (checkToCloseModal) setOpenActionModal(false);
        }
      } catch (error) {
        showToast(
          error?.response?.data?.message || "Error in submit vendor assessment",
          "error",
          true
        );
      }
    } else showToast("Vendor has not submitted all block.", "info", true);
  };
  const onChangeDescription = (e) => {
    setVendorsDetails((prev) => {
      const newData = [...prev];
      newData[vendorTabIndex].assessmentDetails.remarks = e.target.value;
      return newData;
    });
  };

  const putVendorAssessmentDataFun = async () => {
    if (
      vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStatus &&
      vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStandard
    ) {
      try {
        const { data } = await putVendorAssessmentData(caseId, {
          vendorId: vendorsDetails[vendorTabIndex]?.assessmentDetails?.vendorId,
          reportStatus:
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStatus,
          reportStandard:
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStandard,
          submit: false,
        });
        // debugger;

        setVendorsDetails((prev) => {
          const newData = [...prev];
          // if (newData[vendorTabIndex]?.assessmentDetails?.reportStandardScore)
          newData[vendorTabIndex].assessmentDetails.reportStandardScore =
            data?.assessmentDetails?.reportStandardScore;
          // if (newData[vendorTabIndex]?.assessmentDetails?.blockCompleted)
          newData[vendorTabIndex].assessmentDetails.blockCompleted =
            data?.assessmentDetails?.blockCompleted;
          // if (newData[vendorTabIndex]?.assessmentDetails?.blockScore)
          newData[vendorTabIndex].assessmentDetails.blockScore =
            data?.assessmentDetails?.blockScore;
          newData[vendorTabIndex].assessmentDetails.qualityScore =
            data?.assessmentDetails?.qualityScore;
          newData[vendorTabIndex].assessmentDetails.tatScore =
            data?.assessmentDetails?.tatScore;

          return newData;
        });
      } catch (error) {
        showToast(
          error?.response?.data?.message ||
            "Error in updating vendor assessment",
          "error",
          true
        );
      }
    }
    return;
  };

  const handleChangeStandard = async (e) => {
    setVendorsDetails((prev) => {
      const newData = [...prev];

      newData[vendorTabIndex].assessmentDetails.reportStandard = e.target.value;
      return newData;
    });
    await putVendorAssessmentDataFun();
  };

  const handleChangeStatus = async (e) => {
    setVendorsDetails((prev) => {
      const newData = [...prev];
      newData[vendorTabIndex].assessmentDetails.reportStatus = e.target.value;
      return newData;
    });
    await putVendorAssessmentDataFun();
  };

  const labelStyle = {
    display: "flex",
    alignItem: "center",
    fontSize: "1.4rem",
    fontWeight: "400",
  };

  useEffect(() => {
    const getVendorAssessmentDataFun = async () => {
      setLoader(true);
      if (caseId) {
        try {
          const { data } = await getVendorAssessmentData(caseId);
          if (vendorId) {
            const vendorDataVal = data.vendors.filter(
              (item) => item.assessmentDetails.vendorId === vendorId
            );

            const vendorTabsVal = vendorDataVal.map((item, index) => {
              return {
                label: vendorIdToDisplay
                  ? `Vendor ${vendorIdToDisplay}`
                  : `Vendor ${index + 1}`,
                investigationStatus:
                  item.assessmentStatus === "completed"
                    ? "approved"
                    : item.assessmentStatus,
              };
            });
            // setVendorsDetails(data.vendors);
            setVendorsDetails(vendorDataVal);
            setVendorTabs(vendorTabsVal);
          } else {
            const vendorTabsVal = data.vendors.map((item, index) => {
              return {
                label: `Vendor ${index + 1}`,
                investigationStatus:
                  item.assessmentStatus === "completed"
                    ? "approved"
                    : item.assessmentStatus,
              };
            });
            setVendorsDetails(data.vendors);
            setVendorTabs(vendorTabsVal);
          }
          setLoader(false)
        } catch (error) {
          if((error.response.data.message).includes('No Vendors assigned to the case ID')) {
            setVendorAssesmentRequired(false);
          } else {
            showToast(error?.message, "error", true);
          }
          setLoader(false);
        }
      }
    };
    getVendorAssessmentDataFun();
  }, [caseId, vendorId, vendorIdToDisplay]);

  return (
    <>
    {loader ? <CommonLoader /> : (<>
      <div className={style.asses_head} style={vendorAssesmentRequired ? {} : {marginLeft: "-5px"}}>
        <p
          style={{
            fontSize: "1.6rem",
            fontWeight: "600",
          }}
        >
          Vendor Assessment
        </p>
      </div>
      {vendorAssesmentRequired ? (<>
      <MuiTab
        tabs={vendorTabs}
        variant="boxed"
        padding="8px 18.5px"
        onClick={vendorChangeClickHandler}
        activeTab={vendorTabIndex}
      />

      <Box
        sx={{
          flexGrow: 1,
          padding: "1.5rem",
          border: "1px ridge #E8E8E8",
          marginTop: "2rem",
        }}
      >
        <Grid container spacing={{ xs: 2, md: 1 }}>
          <Grid sx={{ marginTop: "1.8rem" }} item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              Report Status <span style={{ color: "#E7373B" }}> *</span>
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <div style={{ width: "100%" }}>
              <CustomSelect
                sx={{ height: "3rem" }}
                placeholder="Select"
                handleChange={handleChangeStatus}
                options={reportStatusOptions}
                customSelectValue={
                  vendorsDetails[vendorTabIndex]?.assessmentDetails
                    ?.reportStatus
                    ? vendorsDetails[vendorTabIndex].assessmentDetails
                        .reportStatus
                    : ""
                }
              />
            </div>
          </Grid>
          <Grid sx={{ marginTop: "1.5rem" }} item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              Report Standard <span style={{ color: "#E7373B" }}> *</span>
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <div style={{ width: "100%" }}>
              <CustomSelect
                sx={{ height: "3rem" }}
                placeholder="Select"
                handleChange={handleChangeStandard}
                options={options}
                customSelectValue={
                  vendorsDetails[vendorTabIndex]?.assessmentDetails
                    ?.reportStandard
                    ? vendorsDetails[vendorTabIndex].assessmentDetails
                        .reportStandard
                    : ""
                }
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={{ xs: 2, md: 3 }} sx={{ paddingTop: "25px" }}>
          <Grid item xs={6} sm={6} md={6} key={"Report Standard Score"}>
            <p style={labelStyle}>Report Standard Score</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStandard
                ? reportStandardValObj[
                    vendorsDetails[vendorTabIndex].assessmentDetails
                      .reportStandard
                  ]
                : null}
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} key={"Investigator Name"}>
            <p style={labelStyle}>Investigator Name</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails?.vendorName
                ? vendorsDetails[vendorTabIndex].assessmentDetails.vendorName
                : null}
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} key={"Block Completed"}>
            <p style={labelStyle}>Block Completed</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails
                ?.blockCompleted ?? null}
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} key={"Block Score"}>
            <p style={labelStyle}>Block Score</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails
                ?.blockCompleted ?? null}
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} key={"Quality Score"}>
            <p style={labelStyle}>Quality Score</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails?.blockScore !==
                null &&
              vendorsDetails[vendorTabIndex]?.assessmentDetails?.blockScore !==
                undefined
                ? parseFloat(
                    vendorsDetails[vendorTabIndex]?.assessmentDetails.blockScore
                  ) +
                  (reportStandardValObj[
                    vendorsDetails[vendorTabIndex]?.assessmentDetails
                      ?.reportStandard
                  ] ?? 0)
                : null}
            </p>
          </Grid>
          <Grid item xs={6} sm={6} md={6} key={"Final Score"}>
            <p style={labelStyle}>Final Score</p>
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <p style={labelStyle}>
              {vendorsDetails[vendorTabIndex]?.assessmentDetails?.tatScore &&
              vendorsDetails[vendorTabIndex]?.assessmentDetails?.qualityScore
                ? vendorsDetails[vendorTabIndex]?.assessmentDetails
                    ?.qualityScore *
                    0.6 +
                  vendorsDetails[vendorTabIndex]?.assessmentDetails?.tatScore
                : null}
            </p>
          </Grid>
        </Grid>
      </Box>

      <div className={style.asses_remark_Btn}>
        <p style={labelStyle}>
          Remark <span style={{ color: "#E7373B" }}> *</span>
        </p>
        <TextField
          sx={{ width: "100%", mt: 1 }}
          id="outlined-multiline-flexible"
          placeholder="Enter Remark"
          multiline
          maxRows={3}
          value={
            vendorsDetails[vendorTabIndex]?.assessmentDetails?.remarks
              ? vendorsDetails[vendorTabIndex].assessmentDetails.remarks
              : ""
          }
          onChange={onChangeDescription}
        />
      </div>
      <div className={style.assesment_Btn}>
        {vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStatus &&
        vendorsDetails[vendorTabIndex]?.assessmentDetails?.reportStandard &&
        vendorsDetails[vendorTabIndex]?.assessmentDetails?.qualityScore &&
        vendorsDetails[vendorTabIndex]?.assessmentDetails?.tatScore &&
        vendorsDetails[vendorTabIndex]?.assessmentDetails?.remarks ? (
          <CommonButton
            onClick={submit}
            label="Submit"
            backgroundColor={"#f1b7b8"}
            sx={{
              fontWeight: "500",
              "&:hover": {
                backgroundColor: "#f1b7b8",
                color: "#e42125",
              },
            }}
            textColor={"#e42125"}
            isColor={true}
            removeBorder
          ></CommonButton>
        ) : (
          <CommonButton
            label="Submit"
            backgroundColor={"#F19092"}
            onClick={() => {
              showToast("Fill all details", "info", true);
            }}
            sx={{
              fontWeight: "500",
              "&:hover": {
                backgroundColor: "#F19092",
                color: "#e42125",
              },
            }}
            textColor={"#e42125"}
            isColor={true}
            removeBorder
          ></CommonButton>
        )}
      </div>
      </>): (
              <p style={labelStyle}>
                Vendor assessment is not required for desktop verification case.
              </p>
          )}
      </>)}
    </>
  );
}
